import styles from './ViewRoutingLoader.module.scss';

function ViewRoutingLoader() {
  return (
    <div className={styles.loading_container}>
      <header>
        <div className={`${styles.heading} animate`}></div>
        <div className={styles.routing_info}>
          {Array(4)
            .fill(0)
            .map((_, i) => (
              <div key={i} className={`${styles.info_item} animate`}></div>
            ))}
        </div>
      </header>
      <div>
        {Array(4)
          .fill(0)
          .map((_, index) => (
            <div className={`${styles.table_row} animate`} key={index}></div>
          ))}
      </div>

      <div className={styles.btn_wrapper}>
        <div className={`${styles.btn} animate`}></div>
        <div className={`${styles.btn} animate`}></div>
      </div>
    </div>
  );
}

export default ViewRoutingLoader;
